<template>
	<div class="stores">
    	<div>点播课程 UserID : {{userId}}  &nbsp;&nbsp; NickName : {{nickname}}</div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData" highlight-current-row  style="width: 100%">
	        		<el-table-column prop="courseId" label="课程"></el-table-column>
			        <el-table-column prop="courseName" label="课程名称"></el-table-column>
			        <el-table-column prop="coachName" label="教练"></el-table-column>
			        <el-table-column prop="coursetime" label="课程首播时间(分钟)" width="200">
			        	<template slot-scope="scope">
	        				{{dateFormatq(scope.row.coursetime)}} ({{scope.row.dtime}})
	        			</template>
			        </el-table-column>
			        <el-table-column prop="calorie" label="卡路里"></el-table-column>
			        <el-table-column prop="totalDistance" label="里程(米)"></el-table-column>
					<el-table-column prop="totalSeconds"  label="时长(秒)"></el-table-column>
			        <el-table-column prop="totalMins" label="完课率">
			        	<template slot-scope="scope">
			        		{{(scope.row.totalMins*100/scope.row.dtime).toFixed(2)}}%
	        			</template>
			        </el-table-column>
			        <el-table-column prop="courseBegin" :formatter="this.global.dateFormat" label="首次时间"></el-table-column>
			        <el-table-column prop="courseEnd" :formatter="this.global.dateFormat" label="末次时间"></el-table-column>
		        </el-table>
	      	</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" :page-sizes="[10, 30, 100, 500]" layout="total, sizes, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	      	<div style="clear:both"></div>
	    </div>
  	</div>
</template>

<script>
export default {
    data() {
      	return {
	        tableData:[],
	        pageNum: 1,
      		limit: 10,
      		totalPage: 10,
      		userId:'',
      		nickname:''
      	};
    },
    methods:{
    	dateFormatq:function(time) {
		    var date = new Date(time);
		    var year=date.getFullYear();
		    var month=date.getMonth()+1<10?'0'+(date.getMonth()+1):date.getMonth()+1;
		    var day=date.getDate()<10?'0'+date.getDate():date.getDate();
		    var hours=date.getHours()<10?'0'+date.getHours():date.getHours();
		    var minutes=date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes();
		    var seconds=date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds();
		    return year+'-'+month+'-'+day+' '+hours+':'+minutes+':'+seconds   
		},
    	init() {
	      	var params = {
	        	pageNum: this.pageNum,
	        	limit: this.limit,
	        	userId:this.userId
	      	};
	      	this.$get("/report/getUserCoursePerformance", params)
	        .then(res => {
	          	if (res.code == 0) {
	            	this.tableData = res.data.list;
	            	this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	    },
    	search_mine(){
    		this.init(); 
    	},
    	//当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
	    handleSizeChange(val){
	    	this.limit=val;
	    	this.pageNum = 1;
	      	this.init();
	    },
    },
    mounted() {
    	this.userId=this.$route.query.id;
    	this.nickname=this.$route.query.nickname;
    	this.init(); 
    },
}
</script>
<style scope>
.sbtn{
	margin-left: 10px
}
.searchBtn{
	display:flex;
	margin: 20px 0;
	align-items: center;
}
.sort{
	margin: 0 10px 0 20px;
	color: #666;
	font-size: 14px;
}
.sortright{
	display: flex;
	align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/views/report/homekcalDetail.vue